import ScrollMagic from 'scrollmagic';

const TextCallout = () => {
  const controller = new ScrollMagic.Controller();

  const textCallouts = document.querySelectorAll('.page-section-text-callout');

  if ( !textCallouts.length ) return

  textCallouts.forEach(textCallout => {
    const scenePanel = new ScrollMagic.Scene({ triggerElement: textCallout })
      .setClassToggle(textCallout, 'active')
      //.addIndicators({ name: 'panel content' }) // Uncomment if needed
      .addTo(controller);
  });
};

export default TextCallout;